import { render, staticRenderFns } from "./CultivationDetails.vue?vue&type=template&id=427fc67a&scoped=true&"
import script from "./CultivationDetails.vue?vue&type=script&lang=js&"
export * from "./CultivationDetails.vue?vue&type=script&lang=js&"
import style0 from "./CultivationDetails.vue?vue&type=style&index=0&id=427fc67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427fc67a",
  null
  
)

export default component.exports